<template>
    <Question
        :question="question"
    />
</template>

<script>
import Question from '../Question';

export default {
    name: 'CompletedView',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        question: 'Желаем успехов в учебе!',
    }),
    components: {
        Question,
    },
};
</script>

<style scoped lang="scss">
</style>